import { Card, StatusMessage } from "@herefor/design-system";
import { IDENTITY_RECONCILIATION_MESSAGES } from "@herefor/product-language";

export interface IdentityReconciliationAlertModel {
  readonly state: "succeeded" | "failed";
  readonly checkedCount: number;
  readonly detectedCount: number;
  readonly repairedCount: number;
  readonly lostAccessCount: number;
  readonly finishedAt: number;
}

/**
 * Counts-only organiser alert. The server decides who may query it; this component
 * receives no identifier, person name, provider payload, or capability list.
 */
export function IdentityReconciliationAlert({
  alert,
}: {
  readonly alert: IdentityReconciliationAlertModel;
}) {
  const failed = alert.state === "failed";
  return (
    <section data-identity-reconciliation-alert={alert.state}>
      <Card title={IDENTITY_RECONCILIATION_MESSAGES.heading}>
        <StatusMessage tone="warning">
          <strong>
            {failed
              ? IDENTITY_RECONCILIATION_MESSAGES.failedTitle
              : IDENTITY_RECONCILIATION_MESSAGES.repairedTitle}
          </strong>
          <p>
            {failed
              ? IDENTITY_RECONCILIATION_MESSAGES.failedBody
              : IDENTITY_RECONCILIATION_MESSAGES.repairedBody(alert.lostAccessCount)}
          </p>
          {failed ? null : (
            <p>
              {IDENTITY_RECONCILIATION_MESSAGES.checkedSummary(
                alert.checkedCount,
                alert.repairedCount,
              )}
            </p>
          )}
        </StatusMessage>
      </Card>
    </section>
  );
}
